<div dropdown class="dropdown">
  <button
    type="button"
    class="btn btn-indigo btn-circle"
    dropdownToggle
    i18n-matTooltip
    matTooltip="Quick option to add new items."
    matTooltipPosition="below"
  >
    <i class="far fa-plus"></i>
  </button>
  <ul class="dropdown-menu dropdown-menu-right global-actions-menu" *dropdownMenu style="width: 430px">
    <li
      *ngFor="let item of universalPlusMenu; let i = index"
      (mouseenter)="onMouseoverMainPlusMenuItem(item, i)"
      cdkOverlayOrigin
      #menuTrigger="cdkOverlayOrigin"
    >
      <button
        class="text-left py-2 ml-3"
        (mouseenter)="btn.classList.add(item.bg)"
        (mouseleave)="btn.classList.remove(item.bg)"
        #btn
      >
        <div>
          <i [ngClass]="item.icon"></i>
        </div>
        <div>
          <div class="text-semi-bold">{{ item.label }}</div>
          <div class="text-sm text-light text-wrap">{{ item.description }}</div>
        </div>
      </button>
      <ng-template
        cdkConnectedOverlay
        (overlayOutsideClick)="item.open = false"
        [cdkConnectedOverlayOffsetX]="-10"
        [cdkConnectedOverlayPositions]="[
          { originX: 'start', originY: 'bottom', overlayX: 'end', overlayY: 'center' },
          { originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top' }
        ]"
        [cdkConnectedOverlayOrigin]="menuTrigger"
        [cdkConnectedOverlayOpen]="item.open"
      >
        <div>
          <ul
            class="dropdown-menu show d-grid"
            (click)="item.open = false"
            style="position: initial"
            [style.grid-template-columns]="item.submenu.length > 5 ? 'repeat(2, 370px)' : 'repeat(1, 360px)'"
          >
            <li *ngFor="let subItem of item.submenu">
              <button class="text-left py-2" (click)="onMenuItemClick(subItem)">
                <div>
                  <i [ngClass]="subItem.icon"></i>
                </div>
                <div>
                  <div class="text-semi-bold">{{ subItem.label }}</div>
                  <div class="text-sm text-light text-wrap">{{ subItem.description }}</div>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </ng-template>
    </li>
  </ul>
</div>
